import EmbeddedFormPage from './EmbeddedFormPage';

const DebitCardPage = () => (
  <EmbeddedFormPage
    titleKey="Debit Card"
    description="Fill out this form to request your Wonderschool Debit Card. The Debit Card connects directly to your Wonderschool account so you get paid faster and can spend on business expenses with your own Wonderschool-branded card."
    formUrl="https://wonderschool.fillout.com/t/c3tZeJYYQYus"
  />
);

export default DebitCardPage;
